import type { SearchProvider, SearchResult } from "../types.ts";
import type UserService from "../../UserService.ts";
import { isNil } from "lodash-es";
import { takeWhere } from "../searchUtil.ts";
import { softContains } from "../../../utils/stringUtil.ts";
import { GroupAvatar } from "../../../components/avatar/Avatar.tsx";
import Text from "../../../components/text/Text.tsx";

export class GroupSearchProvider implements SearchProvider {
  readonly type = "GROUP";

  constructor(
    private readonly groupsQuery: ReturnType<typeof UserService.getGroups>,
    private readonly maxResults: number,
  ) {}

  async search(query: string): Promise<SearchResult[]> {
    if (isNil(this.groupsQuery.data)) {
      return [];
    }

    return Array.from(
      takeWhere(
        this.groupsQuery.data,
        (group) => group.id.equals(query) || softContains(group.name, query),
        this.maxResults,
      ).map((group) => ({
        type: this.type,
        id: group.id.toString(),
        ContentComponent: () => (
          <div
            class="grid min-w-0 grid-cols-template items-center gap-3 px-3 py-2.5"
            style={{
              "--column-template": "auto minmax(0, 1fr)",
            }}
          >
            <GroupAvatar size="sm" group={group} />
            <Text class="text-base-medium text-primary" as="p" text={group.name} truncate />
          </div>
        ),
        actions: {
          Enter: {
            type: "navigate",
            href: (customerId) => `/customers/${customerId}/groups/${group.id}`,
          },
        },
      })),
    );
  }
}
